module.exports = __webpack_public_path__ + "img/SES_210420550.1c7263f2.jpg";